import { render } from "./gamingPage.vue?vue&type=template&id=c304b9fa"
import script from "./gamingPage.vue?vue&type=script&lang=js"
export * from "./gamingPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__